import React, { useState } from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import { useMutation } from '@apollo/react-hooks'
import { useHistory, useLocation } from 'react-router-dom'

import Button from '../../../components/button'
import { useProfile } from '../../../hooks/use-profile'
import { getGQLErrorMsg } from '../../../lib/apollo'
import IMPORT_MY_LIST_SHARE_MUTATION from '../../../../graphql/mutations/import-my-list-share.gql'
import { STATIC_SCREENS } from '../../../constants'
import styles from './confirm-import-list-modal.css'

function ConfirmImportListModal({ onRequestClose }) {
  const history = useHistory()
  const location = useLocation()
  const { token } = qs.parse(location.search)
  const [error, setError] = useState('')
  const { currentProfile } = useProfile('cache-only')
  const [importMyListShare, { loading: saving }] = useMutation(IMPORT_MY_LIST_SHARE_MUTATION)

  const handleConfirmSave = () => {
    setError('')
    importMyListShare({ variables: { token } })
      .then(() => {
        history.replace(STATIC_SCREENS.MY_LISTS.screenId)
      })
      .catch(importError => {
        setError(getGQLErrorMsg(importError))
      })
  }

  const title = `Save list to ${currentProfile?.name ? `${currentProfile.name}'s` : 'your'} profile?`

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {title}
      </div>
      {error && <div className={styles.error}>{error}</div>}
      <div className={styles.buttonGroup}>
        <Button
          wrapperClassName={styles.buttonWrapper}
          className={styles.confirmButton}
          disabled={saving}
          text="Confirm"
          onClick={handleConfirmSave}
        />
        <Button
          wrapperClassName={styles.buttonWrapper}
          className={styles.cancelButton}
          disabled={saving}
          text="Cancel"
          onClick={onRequestClose}
          darkBGSecondary
        />
      </div>
    </div>
  )
}

ConfirmImportListModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired
}

export default ConfirmImportListModal
